export default __webpack_public_path__ + "static/media/Schema.96c10d4c.PNG";